import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CustomerCountryService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CustomerCountries`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IEntity[]> {
        return this.readAll();
    }
}